import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

const PermissionMessages = new Permission();

export async function permissionMessagesFeature(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) {
  const hasPermission = PermissionMessages.can(LIST_PERMISSION.MESSAGES);

  if (hasPermission) {
    next();
    return;
  }

  next({
    name: 'Dashboard'
  });
}
